import React, { FormEventHandler, useState } from 'react'
import log from 'loglevel'
import { RpcError } from 'grpc-web'
import { useHideModal, useIsShowModal } from 'src/Modal/ModalStateContext'
import { ModalForm, ModalFormId } from '../..'
import { FlexAlign, FlexColumn } from '../../../Reusable/Flex'
import { useCreateComplianceFramework } from '../../../async/complianceframework/useComplianceFrameworks'
import { StyledTextInput } from '../../../Reusable/Inputs/TextInput/styles'
import { useAnalytics } from '../../../../analytics/useAnalytics'
import {
  ERROR_MESSAGES,
  FRAMEWORK_MODEL_IDS,
} from '../../../../Utils/globalEnums'
import { getErrorMessage } from '../../../../Utils/globalHelpers'
import {
  StyledComplianceFrameworkInputContainer,
  StyledFieldLabel,
} from './ConfirmFrameworkModal.styles'

const FRAMEWORK_MAX_LENGTH = 50

export const AddCustomFrameworkModal = (): JSX.Element => {
  const [name, setName] = useState('')
  const [error, setError] = useState('')
  const { track, events } = useAnalytics()
  const hide = useHideModal({ modalId: ModalFormId.ADD_CUSTOM_FRAMEWORK })
  const show = useIsShowModal(ModalFormId.ADD_CUSTOM_FRAMEWORK)
  const createCustomFramework = useCreateComplianceFramework()

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    name.length && setError('')
    setName(e.target.value)
  }

  const handleSubmit: FormEventHandler = async (e) => {
    e.preventDefault()
    if (!name.length) {
      setError(ERROR_MESSAGES.EMPTY)
      return
    }
    let resError: RpcError = {} as RpcError
    try {
      track(events.CREATE_FRAMEWORK, {
        modelId: FRAMEWORK_MODEL_IDS.CUSTOM,
        name,
      })
      await createCustomFramework(name)
    } catch (e) {
      resError = e as RpcError
      const errorMessage = getErrorMessage(resError)
      setError(errorMessage.message)
      if (errorMessage.shouldLog) {
        log.error('Error in AddCustomFrameworkModal:', errorMessage.message)
      }
    } finally {
      if (!resError.message) {
        setError('')
        hide()
      }
    }
  }

  return (
    <ModalForm
      show={show}
      hide={hide}
      formId={ModalFormId.ADD_CUSTOM_FRAMEWORK}
      size="xl"
      title="Add Custom Framework"
      submitText="Continue"
    >
      <form id={ModalFormId.ADD_CUSTOM_FRAMEWORK} onSubmit={handleSubmit}>
        <FlexColumn gap={24} align={FlexAlign.FLEX_START}>
          <p>Define a custom framework for your compliance program</p>
          <StyledComplianceFrameworkInputContainer>
            <p>Name</p>
            <StyledTextInput
              onChange={onChange}
              value={name}
              showError={!!error}
              maxLength={FRAMEWORK_MAX_LENGTH}
              placeholder="Enter framework name"
            />
            <StyledFieldLabel
              validateForm={!!error}
              isInvalid={!!error}
              message={error}
            />
          </StyledComplianceFrameworkInputContainer>
        </FlexColumn>
      </form>
    </ModalForm>
  )
}
